import { AnimatePresence } from "framer-motion";
import React, { use, useEffect, useState } from "react";
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { ModalSwitch } from "../Components";
import { accountService, influencerService } from "../Services";
import { PrivateRoute } from "../Helpers";
import {
  Opportunities,
  MyProfile,
  Collaboration,
  Payment,
  Rates,
  Dashboard,
  ReferFriend,
  UserTamaCoin,
  Gallery,
  InfluencerOffer,
  Review,
  InfMessage,
} from "./index";
import AppLayout from "../Components/Layout/AppLayout";
import PublicProfile from "./PublicProfile/PublicProfile";

export default function Influencer({
  user,
  userInfo,
  setChangePage,
  changePage,
  setUser,
  allNotifications,
  setModalNotification,
  setModalNotificationData,
  updateNotificationStatus,
  modalNotification,
  accountCount,
  impersonationBar,
  locationData,
  setShowConfirmInfModal,
  handleAnchorClick,
  setSaveProfile,
  saveProfile,
  setSaveProfileFormValid,
  saveProfileFormValid,
}) {
  const [NotifModul, setNotifModul] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [modal, setModal] = useState(null);
  const [menu, setMenu] = useState(false);
  const [profiles, setProfiles] = useState([]);
  const [toastList, setToastList] = useState([]);
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [newNavigation, setNewNavigation] = useState({});
  const [chatInfo, setChatInfo] = useState(null);
  const [isBasicStepsDone, setIsBasicStepsDone] = useState(false);
  const [offerSelectedForReview, setOfferSelectedForReview] = useState(null);
  useEffect(() => {
    if (user) {
      const rolesWithActive = user?.data?.roles?.map((role) => ({
        ...role,
        active: role.id === user?.data?.active_role ? 1 : 0,
      }));
      setProfiles(rolesWithActive);
      const roleId =
        user["data"]["roles"]?.length > 0
          ? user["data"]["roles"]?.filter(
              (item) => item["id"] == user["data"]["active_role"]
            )[0]["id"]
          : "";
      if (roleId === 3) {
        //navigate('/brand/dashboard');
      } else if (roleId === 2) {
        //navigate('/admin/dashboard');
      }
    }
  }, [user]);

  useEffect(() => {
    if (modal) {
      document.body.classList.add("active");
    } else {
      document.body.classList.remove("active");
    }
  }, [modal]);

  useEffect(() => {
    if (menu) {
      document.body.classList.add("active");
    } else {
      document.body.classList.remove("active");
    }
  }, [menu]);
  useEffect(() => {
    window.scrollTo(0, 0);
    setMenu(false);
    document.body.classList.remove("active");
  }, [location]);
  const close = (e) => {
    if (e.target === e.currentTarget) setMenu(false);
  };

  useEffect(() => {
    if (user) {
      getProfiles();
      getOpporCollabCount();
    }
    // }, [user, searchParams]);
  }, [searchParams]);
  const addToast = (data) => {
    const newToastList = [...toastList];
    const errorMsg = data.msg instanceof Error ? data.msg.message : data.msg;
    newToastList.push({
      ...data,
      msg: errorMsg,
      id: `${Date.now()}-${toastList.length}`,
    });
    setToastList(newToastList);
  };
  async function getProfiles() {
    try {
      // const res = await accountService.getProfiles({});
      // if (res && res["data"]) {
      // console.log(`🚀 ~ getProfiles ~ res["data"]:`, res["data"]);
      // setProfiles(res["data"]["profiles"]);
      // }
      if (
        searchParams.get("sociallogin") !== null &&
        searchParams.get("sociallogin") === "true"
      ) {
        // await accountService.refreshToken(function () {});
      }
    } catch (err) {
      console.error("Profile loading error:", err);
      const errorMsg = err?.message || "Failed to load profile";
      addToast({ error: true, date: new Date(), msg: errorMsg });
    }
  }
  async function getOpporCollabCount() {
    try {
      const res = await influencerService.getCountForBubble({});
      setNewNavigation({
        campaigns_count: res.opportunity_count,
        collaboration_count: res.collaboration_count,
      });
    } catch (err) {
      console.error("Count loading error:", err);
      const errorMsg = err?.message || "Failed to load counts";
      addToast({ error: true, date: new Date(), msg: errorMsg });
    }
  }
  return (
    <>
      <div className={impersonationBar ? "impersonationDivMargin" : ""}>
        {/* <Header
          setModal={setModal}
          menu={menu}
          setMenu={setMenu}
          profiles={profiles}
        />
        <Sidebar
          handleAnchorClick={handleAnchorClick}
          menu={menu}
          close={close}
          user={user}
          type={"influencer"}
          newNavigation={newNavigation}
          isBasicStepsDone={isBasicStepsDone}
          impersonationBar={impersonationBar}
        /> */}
        <AppLayout
          user={user}
          userInfo={userInfo}
          profiles={profiles}
          setModal={setModal}
          NotifModul={allNotifications}
          setModalNotification={setModalNotification}
        >
          <main>
            <Routes>
              <Route
                exact
                path="/opportunities"
                element={
                  <PrivateRoute>
                    <Opportunities
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/profile"
                element={
                  <PrivateRoute>
                    <MyProfile
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      setIsBasicStepsDone={setIsBasicStepsDone}
                      isBasicStepsDone={isBasicStepsDone}
                      setShowConfirmInfModal={setShowConfirmInfModal}
                      setSaveProfile={setSaveProfile}
                      saveProfile={saveProfile}
                      setSaveProfileFormValid={setSaveProfileFormValid}
                      saveProfileFormValid={saveProfileFormValid}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/collaborations"
                element={
                  <PrivateRoute>
                    <Collaboration
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                    />
                  </PrivateRoute>
                }
              />

              <Route
                exact
                path="/payment"
                element={
                  <PrivateRoute>
                    <Payment
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/social_accounts"
                element={
                  <PrivateRoute>
                    <Rates
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      setIsBasicStepsDone={setIsBasicStepsDone}
                      isBasicStepsDone={isBasicStepsDone}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/refer_friend"
                element={
                  <PrivateRoute>
                    <ReferFriend
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/tamacoin"
                element={
                  <PrivateRoute>
                    <UserTamaCoin
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/chat"
                element={
                  <PrivateRoute>
                    <InfMessage
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      onStartChat={(data) => setChatInfo(data)}
                      chatInfo={chatInfo}
                    />
                  </PrivateRoute>
                }
              />

              <Route
                exact
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <Dashboard
                      user={user}
                      setModalSwitch={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setNotifModul={setNotifModul}
                      setModalNotification={setModalNotification}
                      setModalNotificationData={setModalNotificationData}
                      updateNotificationStatus={updateNotificationStatus}
                      accountCountNotification={accountCount}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/gallery"
                element={
                  <PrivateRoute>
                    <Gallery
                      user={user}
                      setModalSwitch={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setNotifModul={setNotifModul}
                      setModalNotification={setModalNotification}
                      setModalNotificationData={setModalNotificationData}
                      updateNotificationStatus={updateNotificationStatus}
                      accountCountNotification={accountCount}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/offers"
                element={
                  <PrivateRoute>
                    <InfluencerOffer
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      onStartChat={(data) => setChatInfo(data)}
                      setOfferSelectedForReview={setOfferSelectedForReview}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/review"
                element={
                  <PrivateRoute>
                    <Review
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      offerSelectedForReview={offerSelectedForReview}
                      setOfferSelectedForReview={setOfferSelectedForReview}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/publicprofile"
                element={
                  <PrivateRoute>
                    <PublicProfile
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      setIsBasicStepsDone={setIsBasicStepsDone}
                      isBasicStepsDone={isBasicStepsDone}
                      setShowConfirmInfModal={setShowConfirmInfModal}
                      setSaveProfile={setSaveProfile}
                      saveProfile={saveProfile}
                      setSaveProfileFormValid={setSaveProfileFormValid}
                      saveProfileFormValid={saveProfileFormValid}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/"
                element={
                  <PrivateRoute>
                    <Dashboard
                      user={user}
                      setModalSwitch={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setNotifModul={setNotifModul}
                      setModalNotification={setModalNotification}
                      setModalNotificationData={setModalNotificationData}
                      updateNotificationStatus={updateNotificationStatus}
                      accountCountNotification={accountCount}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                path="*"
                element={
                  <PrivateRoute>
                    <Dashboard
                      user={user}
                      setModalSwitch={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setNotifModul={setNotifModul}
                      setModalNotification={setModalNotification}
                      setModalNotificationData={setModalNotificationData}
                      updateNotificationStatus={updateNotificationStatus}
                      accountCountNotification={accountCount}
                    />
                  </PrivateRoute>
                }
              />
            </Routes>
          </main>
        </AppLayout>
      </div>
      <AnimatePresence>
        {modal === "switch" && (
          <ModalSwitch
            changePage={changePage}
            setChangePage={setChangePage}
            close={() => setModal(null)}
            profiles={profiles}
          />
        )}
      </AnimatePresence>
    </>
  );
}
